export const SHADOW_TYPE = {
  NO_SHADOW: 'noShadow',
  DROP_SHADOW: 'dropShadow'
};

export const SHADOW_OPTIONS = [
  {
    name: 'No Shadow',
    value: SHADOW_TYPE.NO_SHADOW
  },
  {
    name: 'Drop Shadow',
    value: SHADOW_TYPE.DROP_SHADOW
  }
];

export const SHADOW_VALUE = {
  MIN_ANGLE: -360,
  MAX_ANGLE: 360
};
